import type { TodayClassView } from '@/types/coaching'

/** 주간 순서 — scheduleDays 정렬/표시 보조 (백엔드가 이미 이 순서로 내려주지만 방어적으로 정렬) */
export const WEEK_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const

/**
 * 요일 키 배열을 라벨 문자열로 합친다. 예: ["mon","wed","fri"] + (월/수/금) → "월수금".
 * 라벨 해석(labelOf)은 호출부에서 i18n t()로 주입 — 순수 함수 유지(테스트 용이).
 */
export function formatScheduleDays(days: string[], labelOf: (day: string) => string): string {
  if (!days || days.length === 0) return ''
  return WEEK_ORDER.filter((d) => days.includes(d))
    .map((d) => labelOf(d))
    .join('')
}

/**
 * 자동선택 대상 timeslotId. 백엔드가 recommended=true 를 정확히 1개(또는 0개) 내려준다.
 * recommended 가 없으면 첫 클래스로 폴백. 빈 목록이면 null.
 */
export function pickRecommendedTimeslotId(classes: TodayClassView[]): number | null {
  if (!classes || classes.length === 0) return null
  const recommended = classes.find((c) => c.recommended)
  return (recommended ?? classes[0]).timeslotId
}
